import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const PropertyListingActionsModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('actions');
  const [formData, setFormData] = useState({
    propertyName: '',
    propertyType: 'apartment',
    location: '',
    price: '',
    area: '',
    bedrooms: '',
    bathrooms: '',
    description: '',
    aiEnhance: false,
    autoTranslate: false,
    seoOptimize: false
  });

  const actions = [
    { id: 'ai-generate', icon: 'Sparkles', label: 'إنشاء قائمة بالذكاء الاصطناعي', color: '#3B82F6' },
    { id: 'ai-enhance', icon: 'Wand2', label: 'تحسين الوصف بالذكاء الاصطناعي', color: '#8B5CF6' },
    { id: 'translate', icon: 'Languages', label: 'ترجمة تلقائية (عربي/إنجليزي)', color: '#10B981' },
    { id: 'seo-optimize', icon: 'TrendingUp', label: 'تحسين محركات البحث', color: '#F59E0B' },
    { id: 'quick-template', icon: 'Zap', label: 'قالب سريع', color: '#06B6D4' },
    { id: 'bulk-create', icon: 'Copy', label: 'إنشاء متعدد', color: '#EC4899' }
  ];

  const templates = [
    { id: 'luxury', name: 'عقار فاخر', fields: ['pool', 'garden', 'security'] },
    { id: 'commercial', name: 'عقار تجاري', fields: ['parking', 'elevator', 'security'] },
    { id: 'residential', name: 'عقار سكني', fields: ['bedrooms', 'bathrooms', 'kitchen'] },
    { id: 'land', name: 'أرض', fields: ['area', 'location', 'zoning'] }
  ];

  const handleAction = (actionId) => {
    console.log('Action triggered:', actionId);
    // OpenAI integration logic here
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="قوائم العقارات - الإجراءات والقوالب"
      footer={null}
      icon={null}
      iconColor={null}
    >
      <div className="space-y-6">
        <div className="flex gap-2 border-b border-border">
          <button
            onClick={() => setActiveTab('actions')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'actions' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            الإجراءات
          </button>
          <button
            onClick={() => setActiveTab('templates')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'templates' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            القوالب
          </button>
          <button
            onClick={() => setActiveTab('fields')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'fields' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            الحقول
          </button>
        </div>

        {activeTab === 'actions' && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              {actions?.map((action) => (
                <button
                  key={action?.id}
                  onClick={() => handleAction(action?.id)}
                  className="p-4 rounded-lg border border-border hover:border-primary transition-all text-right group"
                >
                  <div className="flex items-center gap-3">
                    <div
                      className="w-10 h-10 rounded-lg flex items-center justify-center"
                      style={{ backgroundColor: `${action?.color}20` }}
                    >
                      <Icon name={action?.icon} size={20} color={action?.color} />
                    </div>
                    <span className="text-sm font-medium text-foreground group-hover:text-primary">
                      {action?.label}
                    </span>
                  </div>
                </button>
              ))}
            </div>

            <div className="bg-muted/50 rounded-lg p-4 space-y-3">
              <h3 className="text-sm font-semibold text-foreground flex items-center gap-2">
                <Icon name="Settings" size={16} />
                خيارات الذكاء الاصطناعي
              </h3>
              <div className="space-y-2">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData?.aiEnhance}
                    onChange={(e) => handleInputChange('aiEnhance', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">تحسين تلقائي للوصف</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData?.autoTranslate}
                    onChange={(e) => handleInputChange('autoTranslate', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">ترجمة تلقائية</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData?.seoOptimize}
                    onChange={(e) => handleInputChange('seoOptimize', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">تحسين SEO</span>
                </label>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'templates' && (
          <div className="space-y-3">
            {templates?.map((template) => (
              <div
                key={template?.id}
                className="p-4 rounded-lg border border-border hover:border-primary transition-all cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="text-sm font-semibold text-foreground">{template?.name}</h4>
                    <p className="text-xs text-muted-foreground mt-1">
                      {template?.fields?.length} حقول مخصصة
                    </p>
                  </div>
                  <Button variant="outline" size="sm">
                    استخدام
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'fields' && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <Input
                label="اسم العقار"
                value={formData?.propertyName}
                onChange={(e) => handleInputChange('propertyName', e?.target?.value)}
                placeholder="أدخل اسم العقار"
              />
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">نوع العقار</label>
                <select
                  value={formData?.propertyType}
                  onChange={(e) => handleInputChange('propertyType', e?.target?.value)}
                  className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground"
                >
                  <option value="apartment">شقة</option>
                  <option value="villa">فيلا</option>
                  <option value="land">أرض</option>
                  <option value="commercial">تجاري</option>
                </select>
              </div>
              <Input
                label="الموقع"
                value={formData?.location}
                onChange={(e) => handleInputChange('location', e?.target?.value)}
                placeholder="المدينة، الحي"
              />
              <Input
                label="السعر"
                type="number"
                value={formData?.price}
                onChange={(e) => handleInputChange('price', e?.target?.value)}
                placeholder="0"
              />
              <Input
                label="المساحة (م²)"
                type="number"
                value={formData?.area}
                onChange={(e) => handleInputChange('area', e?.target?.value)}
                placeholder="0"
              />
              <Input
                label="غرف النوم"
                type="number"
                value={formData?.bedrooms}
                onChange={(e) => handleInputChange('bedrooms', e?.target?.value)}
                placeholder="0"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">الوصف</label>
              <textarea
                value={formData?.description}
                onChange={(e) => handleInputChange('description', e?.target?.value)}
                placeholder="وصف تفصيلي للعقار..."
                rows={4}
                className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground resize-none"
              />
            </div>
          </div>
        )}

        <div className="flex justify-end gap-3 pt-4 border-t border-border">
          <Button variant="outline" onClick={onClose}>
            إلغاء
          </Button>
          <Button variant="default">
            تطبيق
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PropertyListingActionsModal;